import type { User } from '../types/user'

export const parseJwt = (token: string): Record<string, unknown> => {
  if (!token) {
    return {}
  }

  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join('')
    )

    return JSON.parse(jsonPayload)
  } catch (error) {
    console.error('Failed to parse JWT:', error)

    return {}
  }
}

export const jwtToUser = (parsedJwt: Record<string, unknown>): User => {
  return {
    email_verified: parsedJwt.email_verified as boolean,
    name: parsedJwt.name as string,
    preferred_username: parsedJwt.preferred_username as string,
    given_name: parsedJwt.given_name as string,
    family_name: parsedJwt.family_name as string,
    email: parsedJwt.email as string,
  }
}
